import type { AbsenceAmountInput, AbsenceOperation, AbsencePortion } from './absence-payload.model';

export interface AbsenceDetailBefore {
  absenceTypeSlug?: string;
  absenceTypeLabel?: string;
  from?: string;
  to?: string;
  portion?: AbsencePortion;
  fractionValue?: number;
  durationMinutes?: number;
  startTime?: string;
  endTime?: string;
}

export interface AbsenceDetailContext {
  person: { id: string; displayName: string; avatarUrl?: string | null };
  absenceType: { slug: string; label: string; icon?: string | null; color?: string | null };
  operation: AbsenceOperation;
  from: string;
  to: string;
  portion: AbsenceAmountInput;
  workingDays: string[];
  balanceImpact: { hours: number; days: number };
  remainingBalance: { hours: number; days: number; account: string } | null;
  before?: AbsenceDetailBefore;
}
